// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"eee17ec53a9347a1512a","9249":"0adddc1fa7eded08d884"}[chunkId] + ".chunk.js";
};